import { Box } from '@medly-components/core';
import styled from 'styled-components';

import { OnboardingPageBackgroundBox } from 'components/common/OnboardingPageWrapper/OnboardingPageWrapper.style';
import coral from '../../theme/colors/coral';
import { QuestionnaireBackgroundImages } from './types';

import Question1Large from '../../assets/images/questionnaire/question1/large.png';
import Question1Medium from '../../assets/images/questionnaire/question1/medium.png';
import Question1Small from '../../assets/images/questionnaire/question1/small.png';
import Question1xl from '../../assets/images/questionnaire/question1/xl.png';

import Question2Large from '../../assets/images/questionnaire/question2/large.png';
import Question2Medium from '../../assets/images/questionnaire/question2/medium.png';
import Question2Small from '../../assets/images/questionnaire/question2/small.png';
import Question2xl from '../../assets/images/questionnaire/question2/xl.png';

import Question3Large from '../../assets/images/questionnaire/question3/large.png';
import Question3Medium from '../../assets/images/questionnaire/question3/medium.png';
import Question3Small from '../../assets/images/questionnaire/question3/small.png';
import Question3xl from '../../assets/images/questionnaire/question3/xl.png';

const backgroundImages: QuestionnaireBackgroundImages[] = [
    { xlImg: Question1xl, lgImg: Question1Large, mdImg: Question1Medium, smImg: Question1Small },
    { xlImg: Question2xl, lgImg: Question2Large, mdImg: Question2Medium, smImg: Question2Small },
    { xlImg: Question3xl, lgImg: Question3Large, mdImg: Question3Medium, smImg: Question3Small }
];

export const QuestionnaireFormWrapper = styled(Box)`
    height: auto;
    background: none;
    display: block;
    padding: 0 2.4rem;
    margin: 4.2rem 0;
    z-index: 10;
    @media (min-width: ${({ theme }) => {
            return theme.breakpoints.S.max;
        }}px) {
        max-width: 50rem;
        margin: 7.2rem;
    }
`;

export const QuestionnairePageWrapper = styled(OnboardingPageBackgroundBox)<{ currentPageIndex: number }>`
    ${({ currentPageIndex, theme }) => {
        const xlImg = backgroundImages[currentPageIndex].xlImg;
        const lgImg = backgroundImages[currentPageIndex].lgImg;
        const mdImg = backgroundImages[currentPageIndex].mdImg;
        const smImg = backgroundImages[currentPageIndex].smImg;
        let backgroundSize;
        let paddingBottom = '65%'; // To place background image
        if (currentPageIndex === 0) {
            backgroundSize = '';
            paddingBottom = '75%';
        } else if (currentPageIndex === 1) {
            backgroundSize = '79%';
        } else {
            backgroundSize = '66%';
        }

        return `
    background-image: url(${xlImg});
${
    currentPageIndex === 2
        ? `
    background-size:85%;
    background-position:bottom right;
`
        : ''
}

    @media (max-width: ${theme.breakpoints.L.max}px) {
        background-size:${backgroundSize};
        background-image: url(${lgImg});
    }

    @media (max-width: ${theme.breakpoints.M.max}px) {
        background-image: url(${mdImg});
        margin-bottom: 6.4rem;
            padding-bottom: ${paddingBottom};
    }

    @media (max-width: ${theme.breakpoints.S.max}px) {
        background-image: url(${smImg});
            padding-bottom: calc(${paddingBottom} + 40%);
    }`;
    }}
`;

export const QuestionBox = styled(Box)`
    display: flex;
    gap: 0.8rem;
    height: 5.6rem;
    padding: 0;
    align-items: center;
    cursor: pointer;
    border-radius: 0.8rem;
    background: #fff;
    box-shadow: 0 0.2rem 0.8rem 0 rgba(176, 188, 200, 0.2);
    padding-left: 1.6rem;
    box-sizing: border-box;
    border: 0.2rem solid ${props => (props.selected ? coral[500] : 'transparent')};
    input:not(:placeholder-shown) ~ label,
    input:focus ~ label {
        transform: translateY(-100%);
        font-size: 1.2rem;
    }
`;

export const OptionsContainer = styled(Box)`
    display: flex;
    padding: 0;
    margin: 2.4rem 0 0;
    flex-direction: column;
    row-gap: 2.4rem;
    background: none;
`;
